// pkce.util.ts
export class PKCEUtil {
  private static readonly CHARSET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
  private static readonly CODE_VERIFIER_LENGTH = 128;

  static generateRandomString(length: number): string {
    return Array.from(crypto.getRandomValues(new Uint8Array(length)))
      .map(x => this.CHARSET[x % this.CHARSET.length])
      .join('');
  }

  static generateCodeVerifier(): string {
    return this.generateRandomString(this.CODE_VERIFIER_LENGTH);
  }

  static async generateCodeChallenge(codeVerifier: string): Promise<string> {
    const encoder = new TextEncoder();
    const data = encoder.encode(codeVerifier);
    const digest = await crypto.subtle.digest('SHA-256', data);
    const base64Digest = btoa(String.fromCharCode(...new Uint8Array(digest)))
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '');
    return base64Digest;
  }
}
